import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/* Elementor-style scroll-triggered entrance animations.
   Classes are added only via JS so prerendered HTML stays fully visible. */
export const ScrollReveal = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('ele-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0 });

    const process = () => {
      document.querySelectorAll('main section').forEach((el) => {
        if (!el.hasAttribute('data-ele')) {
          el.setAttribute('data-ele', '1');
          if (el.getBoundingClientRect().top > window.innerHeight * 0.85) {
            el.classList.add('ele-reveal');
          }
        }
        if (el.classList.contains('ele-reveal') && !el.classList.contains('ele-in')) {
          io.observe(el);
        }
      });
    };

    let ticking = false;
    const sweep = () => {
      ticking = false;
      document.querySelectorAll('main section.ele-reveal:not(.ele-in)').forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
          el.classList.add('ele-in');
          io.unobserve(el);
        }
      });
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(sweep);
      }
    };

    process();
    const t1 = setTimeout(process, 350);
    const t2 = setTimeout(process, 1200);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      window.removeEventListener('scroll', onScroll);
      io.disconnect();
    };
  }, [pathname]);

  return null;
};

export default ScrollReveal;
